import { Outlet } from 'react-router';

const Template = () => {
  return <Outlet />;
};

export default Template;
